import { Paper} from "@mui/material"
import dayjs from "dayjs";
import { useEffect, useState } from "react"
import DonutChart from "./DonutChart";

function Dashboard() {

    const [currentDate, setCurrentdate] = useState('')

    useEffect(() => {
        setCurrentdate(dayjs().format('MMMM'));
    })


    return (

        <div>
            <Paper className="grid grid-cols-12 mt-3">
                <div className="col-span-12 ">
                    <span className="bg-green-600 px-3 py-1 rounded-lg text-white relative bottom-2" ><strong>{currentDate}</strong></span>
                </div>
                <div className="col-span-2 p-2 px-8">
                    <div className="bg-blue-700 flex items-center justify-around h-16 rounded-xl">
                        <strong className="text-white" >Total</strong>
                        <strong className="text-white" >10</strong>
                    </div>
                </div>
                <div className="col-span-2 p-2 px-8">
                    <div className="bg-green-700 flex items-center justify-around h-16 rounded-xl">
                        <strong className="text-white" >Claimed</strong>
                        <strong className="text-white" >10</strong>
                    </div>
                </div>
                <div className="col-span-2 p-2 px-8">
                    <div className="bg-red-600 flex items-center justify-around h-16 rounded-xl">
                        <strong className="text-white" >Rejected</strong>
                        <strong className="text-white" >10</strong>
                    </div>
                </div>
                <div className="col-span-2 p-2 px-8">
                    <div className="bg-orange-400 flex items-center justify-around h-16 rounded-xl">
                        <strong className="text-white" >Active</strong>
                        <strong className="text-white" >10</strong>
                    </div>
                </div>
                <div className="col-span-2 p-2 px-8">
                    <div className="bg-gray-700 flex items-center justify-around h-16 rounded-xl">
                        <strong className="text-white" >Submitted</strong>
                        <strong className="text-white" >10</strong>
                    </div>
                </div>
                <div className="col-span-2 p-2 px-8">
                    <div className="bg-cyan-600 flex items-center justify-around h-16 rounded-xl">
                        <strong className="text-white" >Prior Approval</strong>
                        <strong className="text-white" >10</strong>
                    </div>
                </div>
            </Paper>


            <div className="grid grid-cols-12 ">

                <div className="  bg-green-300 h-[75vh] col-span-12 ">
                    <div className="col-span-12 p-3"><strong className=" mt-3">Quick View</strong></div>




                    <div className="flex flex-row justify-around">
                        <div><DonutChart /></div>

                        <div className=" flex flex-col w-[20vw] ">
                            <div className="p-2 bg-white m-3 rounded-xl flex flex-col justify-center items-center hover:bg-slate-200 cursor-pointer ">
                                <strong >Claim Listing</strong>

                            </div>
                            <div className="p-2 bg-white m-3 rounded-xl flex flex-col justify-center items-center hover:bg-slate-200 cursor-pointer ">
                                <strong >Processed Claims</strong>

                            </div>
                            <div className="p-2 bg-white m-3 rounded-xl flex flex-col justify-center items-center hover:bg-slate-200 cursor-pointer ">
                                <strong >Remitance</strong>

                            </div>
                            <div className="p-2 bg-white m-3 rounded-xl flex flex-col justify-center items-center hover:bg-slate-200 cursor-pointer ">
                                <strong >prior Approval</strong>

                            </div>
                            <div className="p-2 bg-white m-3 rounded-xl flex flex-col justify-center items-center hover:bg-slate-200 cursor-pointer ">
                                <strong >Verifiacation</strong>

                            </div>

                        </div>



                    </div>


                </div>

            </div>


        </div>
    )
}

export default Dashboard
